import { configureStore } from "@reduxjs/toolkit";
import patientReducer from "./reducers/patient";

export default configureStore({
  reducer: {
    patient: patientReducer,
  },
});
